export default __webpack_public_path__ + "canvas-corner-clean.8bc28c.png";